import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FormControlLabel, FormControl, FormHelperText, Grid } from '@material-ui/core';
import { useStyles } from '../../styles';
import { useStateMachine } from 'little-state-machine';
import { updateAction } from '../../actions';
import { useForm, Controller } from 'react-hook-form';
import api from '../../../../../services/api';
import { Colors, UserType } from '../../../../../enums/enums';
import { IFormProps } from './section.interface';
import { Divider, Typography, Button, Radio, RadioGroup } from '@mui/material';

interface IFormClientProps extends IFormProps {
  survey: { id: string; clientId: string; company: string; surveyId: string };
}

const Section4: React.FC<IFormClientProps> = ({ step, setStep, survey }) => {
  const { state, actions } = useStateMachine({
    updateAction
  });

  const { handleSubmit, getValues, control, formState } = useForm({
    defaultValues: state?.formDetails?.all
  });

  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  React.useEffect(() => {
    if (formState.isSubmitSuccessful) {
      handleComplete();
      setStep(step + 1);
    }
  }, [formState, state]);

  const handleBack = () => {
    const partialData = getValues();
    actions.updateAction({ formDetails: { all: partialData } } as any);
    setStep(step - 1);
  };

  const handleComplete = (): void => {
    const data = {
      type: UserType.All,
      client: survey?.company,
      clientId: survey?.clientId,
      surveyId: survey?.id,
      email: state.formDetails.all.email,
      formResponse: state.formDetails.all
    };
    console.log('Data ONBOARDING', data);
    api.post('/surveys/onboarding-general', data).then((value) => {
      // clear out session storage
      actions.updateAction({
        formDetails: {
          all: null
        }
      } as any);
    });
  };

  const onSubmit = (data: any) => {
    actions.updateAction({
      formDetails: {
        all: {
          ...data,
          clientId: survey?.clientId,
          clientName: survey?.company
        }
      }
    } as any);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography textAlign="center" variant="h5" sx={{ color: Colors.TextElevated, mb: 3 }}>
        Terms and Conditions
      </Typography>
      <Divider sx={{ mb: 2, width: '667px', ml: 5 }} />
      <Grid style={{ margin: 0 }} container spacing={5} alignItems="center" justifyContent="center">
        <Grid style={{ justifyContent: 'center', alignItems: 'center' }} item>
          <div
            className={classes.formLabel}
            style={{ margin: 0, backgroundColor: Colors.BackgroundMain, width: '667px', color: Colors.TextElevated }}
          >
            <li style={{ listStyleType: 'none' }}>
              <ul className={classes.formLabel} style={{ padding: '0' }}>
                <Typography component="p" sx={{ ml: 3 }}>
                  <b>Terms and Conditions:</b>
                </Typography>
              </ul>

              <ul className={classes.formLabel}>
                <Typography component="p" sx={{ mb: -2 }}>
                  <b>1. Canceled or Missed Sessions:</b>
                </Typography>
                <br />
                {'>'} 1:1 Sessions: Please allow at least 48 hours before canceling a session to be rescheduled.
                Sessions canceled within 48 hours of the upcoming session may not be rescheduled. If a mentor or coach
                cancels, those sessions will be rescheduled.
                <br />
                {'>'} Group Sessions: Group sessions can’t be canceled unless the mentor or coach is unavailable in
                which case they will be rescheduled.
                <br />
                {'>'} No shows: These sessions will not be rescheduled. If more than 2 no shows, the cohort will end.
              </ul>

              <ul className={classes.formLabel}>
                <Typography component="p" sx={{ mb: -2 }}>
                  <b>2. Confidentiality:</b>
                </Typography>
                <br />
                All communications with your match are confidential, but Locelle/BestHuman may reach out to ask for
                testimonials to be shared for marketing purposes. Your consent will be important and you will be asked
                prior.
              </ul>

              <ul className={classes.formLabel}>
                <Typography component="p" sx={{ mb: -2 }}>
                  <b>3. Satisfaction:</b>
                </Typography>
                <br />
                {'>'}1:1 If you are not satisfied with your match, please let your Client Success team member know.
                <br />
                {'>'} Group: If you are not satisfied with the group, we will cancel your plan and refund for all
                remaining sessions.
              </ul>

              <ul className={classes.formLabel}>
                <Typography component="p" sx={{ mb: -2 }}>
                  <b>4. Liability</b>
                </Typography>
                <br />
                Locelle/BestHuman, the mentors, coaches and/or your employer is not liable or responsible for any
                decisions you make as a result of participating in the program
              </ul>
              <ul className={classes.formLabel}>
                <Typography component="p" sx={{ mb: -2 }}>
                  <b>Consent to Participate</b>
                </Typography>
                <br />
                By participating, you agree to uphold confidentiality and non-disclosure pertaining to all sessions and
                programs facilitated by BestHuman.
              </ul>
            </li>
          </div>
        </Grid>

        <Grid item xs={12} style={{ marginLeft: 20 }}>
          <FormControl>
            <Controller
              render={({ field }) => (
                <RadioGroup row {...field}>
                  <FormControlLabel
                    value="agree"
                    control={<Radio color="success" />}
                    label="I agree to the terms and conditions"
                    labelPlacement="end"
                  />
                </RadioGroup>
              )}
              name="confidentiality"
              control={control}
              rules={{ required: true }}
            />
            {formState.errors?.confidentiality?.type === 'required' && (
              <FormHelperText className={classes.errorText}>Required</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="outlined" color="success" onClick={() => handleBack()}>
            BACK
          </Button>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="contained" color="success" type="submit">
            SUBMIT
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Section4;
